import React, { useEffect, useState } from 'react';
import { polyfill } from "mobile-drag-drop";
import { renderFormattedText } from "../../utils/helpers";
import { useData } from "../../components/context/DataContext";
import { useResult, useResultUpdate } from "../../components/context/ResultContext";
import { useRandom, useRandomUpdate } from "../../components/context/RandomContext";
import { gaQuiz } from '../../utils/gatags';



// optional import of scroll behaviour
import {scrollBehaviourDragImageTranslateOverride} from "mobile-drag-drop/scroll-behaviour";

import './DragDrop.css';
import Results from '../../components/Results/Results';

const DragDrop = (props) => {

    const json = useData();
    
    polyfill({
        // use this to make use of the scroll behaviour
        dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
    });

    let dropArray = [null, null,null,null];
    const correctArray = ["drag0", "drag1", "drag2", "drag3"];
    const initArray = [];

    let lastTap = 0;
    let timeout;

    const [ddArray, setDdArray] = useState([]);
    const ddInit = 0;
    const userResult = useResult();
    const setUserResult = useResultUpdate();
    const getRandom = useRandom();
    const setRandom = useRandomUpdate();
    const _body = document.getElementById("dd-body");

    useEffect(() => {
        dragMode(true);
        init();
    },[]);

    function init() {
        checkNulls();
        const fills = document.querySelectorAll('.fill');
        const empts = document.querySelectorAll('.empty');
        fills.forEach( (drag, index) => {
            addFillListen(drag, index);
        })
        empts.forEach( (drop, index) => {
            addEmptyListen(drop, index);
        })
    }

    // ADD LISTENERS

    function addEmptyListen(drop, index) {
        drop.id = "drop" + index;
        drop.addEventListener('dragover', dragOver);
        drop.addEventListener('dragenter', dragEnter);
        drop.addEventListener('dragleave', dragLeave);
        drop.addEventListener('drop', dragDrop);
    }

    function addFillListen(drag, index) {
        drag.id = "drag" + getRandom[index];
        drag.addEventListener('dragstart', dragStart);
        drag.addEventListener('dragend', dragEnd);
        drag.addEventListener("pointerup", doubleTapHandler);
    }
        



    // document.addEventListener('pointerdown', function(event) {
    //   if (event.target.classList.contains('draggable')) {
    //     setIsDragging(true);
    //     // Prevent scrolling while dragging
        
    //     console.log("prevent down");
    //     event.preventDefault();
    //   }
    // });
    
    // document.addEventListener('pointermove', function(event) {
    //   if (isDragging) {
    //     // Do your dragging logic here
    //     // ...
    //     // Prevent scrolling while dragging
    //     console.log("prevent move");
    //     event.preventDefault();
    //   }
    // });
    
    // document.addEventListener('pointerup', function(event) {
    //     setIsDragging(false);
    // });



    // Drag functions

    function dragStart (e) {
        _body.classList.add("disableTouch");

  e.dataTransfer.setData('text', e.target.id);

        this.classList.add("hold");setTimeout(() => {
            setNoteCopy(e.target.getAttribute("idx"));      
        showNotes();
          }, 200);
      
        
    }
    function dragEnd(e) {
        _body.classList.remove("disableTouch");
        e.preventDefault();
        this.classList.remove("hold");
    }
    function dragOver(e) {
        e.preventDefault();
    }
    function dragEnter(e) {
        e.preventDefault();
        this.classList.add("hovered");
    }
    function dragLeave(e) {
        this.classList.remove("hovered");
    }
    function dragDrop(e) {
        if ( initArray.length < 1) {
            gaQuiz('init', 0, 0);
            initArray.push("1");
        }
        _body.classList.remove("disableTouch");
        e.preventDefault();
        this.classList.remove("hovered");
        dropArray[parseInt(e.target.getAttribute('idx'))] = document.getElementById(e.dataTransfer.getData('text')).id;
        this.append(document.getElementById(e.dataTransfer.getData('text')));
        let count = this.children.length;
        if (count > 1 ) {
            const repEl = document.getElementById('dh' + this.firstElementChild.getAttribute("idx"));
            repEl.append(this.firstElementChild);
        }
        const empties = document.querySelectorAll('.empty');
        empties.forEach( (el, idx) => {
            if (el.children[0]) {
                dropArray[idx] = el.children[0].getAttribute("id");
            } else {
                dropArray[idx] = null;
            }
        })
        checkNulls();
    }

    function dragMode(dragmode) {
        document.querySelectorAll(".fill").forEach((el, idx) => {
            if (dragmode) {
                el.setAttribute('draggable', true);
            } else {
                el.setAttribute('draggable', false);
            }
        });
    }
    

    function dragreset(e) {
        if ( e.parentElement.id !== 'drag-holder' ) {
            
            dropArray.splice(parseInt(e.parentElement.getAttribute('idx')), 1, null);
            const repEl = document.getElementById('dh' + e.getAttribute('idx'));
            repEl.appendChild(e);
        }
        checkNulls();
        hideNotes();
    }


    // CHECK NULLS

    function checkNulls() {
        let arraycount = 0;
        let exist = false;
        for (let i = 0; i < dropArray.length; i++) {
            if (dropArray[i] != null) {
                exist = true;
                arraycount = arraycount+1;
            }
        }
        if ( arraycount === 4 ) {
            // setSubmitReady(true);
            checkResult();
        } else {
            // setSubmitReady(false);
        }
        return exist;
    }
    // checkNulls();


    // CHECK RESULT

    function checkResult() {
        const submit = document.getElementById("submitButton");
        submit.classList.add("show-submit"); 
        setDdArray(dropArray);
        // const submitbutton = document.getElementById("submitresult");
    }

    function submitBtnClicked() {

        const dragHolder = document.getElementById("drag-holder"); 
        dragHolder.classList.add("hide-elem");
        setUserResult.setattempts(userResult.attempts+1)
        hideNotes();
        const submit = document.getElementById("submitButton");
        // const submitbutton = document.getElementById("submitresult");
        submit.classList.remove("show-submit");
        const results = document.getElementById("results");
        results.classList.add("show-results");
        dragMode(false);
        const matchingCount = countMatchingElements(ddArray, correctArray);

        console.log(userResult.attempts)

        if ( matchingCount === 4 && userResult.attempts < 3 ) {
            setUserResult.setuserresultid(1);
            gaQuiz('complete', matchingCount, userResult.attempts+1);
        }
        if ( matchingCount<4 && userResult.attempts < 3 ) {
            setUserResult.setuserresultid(2);
            gaQuiz('start', matchingCount, userResult.attempts+1);
        }
        if ( matchingCount<4 && userResult.attempts === 2 ) {
            setUserResult.setuserresultid(3);
            gaQuiz('complete', matchingCount, userResult.attempts+1);
        }
        setUserResult.setresult(matchingCount);
    }


    function countMatchingElements(arr1, arr2) {
        let count = 0;
        for (let i = 0; i < arr1.length; i++) {
          if (arr2[i] === arr1[i]) {
            count++;
          }
        }
        return count;
    }
    // function resetArray() {
    //     document.querySelectorAll(".empty").forEach((el, idx) => {
    //         if (el.firstElementChild) {
    //             dropArray[idx] = el.id;
    //         } else {
    //             dropArray[idx] = null;
    //         }
    //     });
        
    // }



    // NOTES
    
    function setNoteCopy(idx) {
        // note 1
        const note1head1 = document.getElementById("n1-head1");
        const note1head2 = document.getElementById("n1-head2");
        const note1copy = document.getElementById("note1copy");
        const note2head1 = document.getElementById("n2-head1");
        const note2head2 = document.getElementById("n2-head2");
        const note2copy = document.getElementById("note2copy");
        // note 2
        note1head1.innerHTML = json.notes[idx].note[0].head1;
        note1head2.innerHTML = json.notes[idx].note[0].head2;
        note1copy.innerHTML = json.notes[idx].note[0].note;
        note2head1.innerHTML = json.notes[idx].note[1].head1;
        note2head2.innerHTML = json.notes[idx].note[1].head2;
        note2copy.innerHTML = json.notes[idx].note[1].note;
    }

    function showNotes() {
        var elements = document.getElementsByClassName("note");
        for (var i = 0, len = elements.length; i < len; i++) {
            elements[i].classList.add('note-active');
        }
    }
    function hideNotes() {
        var elements = document.getElementsByClassName("note");
        for (var i = 0, len = elements.length; i < len; i++) {
            elements[i].classList.remove('note-active');
        }
    }


    // DOUBLE TAP HANDLER

    function doubleTapHandler(e) {
        let currentTime = new Date().getTime();
        let tapLength = currentTime - lastTap;
        
        if (tapLength < 500 && tapLength > 0) {
        clearTimeout(timeout);
        e.preventDefault();
        // Double tap detected
        checkNulls();
        dragreset(e.target)
        } else {
        timeout = setTimeout(function() {
            clearTimeout(timeout);
        }, 500);
        }
        lastTap = currentTime;
    }

    // RESET APP
    function resetApp() {
        setRandom();
        // randArray = randomArray();
        const fills = document.querySelectorAll('.fill');
        fills.forEach( (el, idx) => {
            const repEl = document.getElementById('dh' + el.getAttribute('idx'));
            repEl.appendChild(el);
        })
        const submitBtn = document.getElementById("submitButton");
        submitBtn.classList.remove("show-submit");
        const review = document.getElementById("results");
        review.classList.remove("show-results");
        const dragHolder = document.getElementById("drag-holder");
        dragHolder.classList.remove("hide-elem");
        setDdArray([])
        dragMode(true);

    }


    return (
        <>
        {/* {userResult.attempts} - {userResult.result} */}
            <div className="dd-wrapper"> 
                <div className="tri-heads">
                    <div className="tri-heads-copy">
                        <h3>{json && renderFormattedText(json.content[0].trihead1)}</h3>
                    </div>
                    <div className="tri-heads-copy">
                        <h3>{json && renderFormattedText(json.content[0].trihead2)}</h3>
                    </div>
                </div>
                <div className="empty-wrap">
                    <div className="empty" idx="0"></div>
                    <div className="empty" idx="1"></div>
                    <div className="empty" idx="2"></div>
                    <div className="empty" idx="3"></div>
                </div>
                <div id="drag-holder" className="drag-holder">
                    <div id={`dh${getRandom[0]}`} className="drag-item-holder">
                        <div className={`draggable fill fill${getRandom[0]}`} draggable="true" idx={getRandom[0]}></div>
                    </div>
                    <div id={`dh${getRandom[1]}`} className="drag-item-holder">
                        <div className={`draggable fill fill${getRandom[1]}`} draggable="true" idx={getRandom[1]}></div>
                    </div>
                    <div id={`dh${getRandom[2]}`} className="drag-item-holder">
                        <div className={`draggable fill fill${getRandom[2]}`} draggable="true" idx={getRandom[2]}></div>
                    </div>
                    <div id={`dh${getRandom[3]}`} className="drag-item-holder">
                        <div className={`draggable fill fill${getRandom[3]}`} draggable="true" idx={getRandom[3]}></div>
                    </div>
                </div>
            </div>
            <div id="submitButton" className="feedback">
                
                <div onClick={submitBtnClicked} id="submitresult" className="feedback-btn">Show results</div>
            </div>
            <Results clickhandle={resetApp} />
        </>
    );
};

export default DragDrop;